import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import { successMessage, errorMessage } from "../CommonFunctions";
import {
  POST_InventoryItemIssueInsert,
  POST_GetInventoryItemsListDLL,
  POST_GetInventoryItemStockDDLListByID,
  POST_GetEmployeeDDLList,
} from "../../../helpers/url_helper";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import { SVGICON } from "../../../constant/theme";
import CustomInput from "../../../CustomControls/CustomInput";

const AddInventoryItemIssue = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();
  const [itemOptions, setItemsOptions] = useState([]);
  const [itemStockOptions, setItemStockOptions] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [employeeOptions, setEmployeeOptions] = useState([]);

  useEffect(() => {
    getInventoryItemsDDL();
    getEmployeeDDL();
  }, []);

  const getEmployeeDDL = async () => {
    setIsLoading(true);
    await post(POST_GetEmployeeDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      UserType: AuthUser?.UserType,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEmployeeOptions(
            response?.EmployeeList?.map((item) => ({
              label: item.EmployeeName,
              value: item.EmployeeIDEncrypted,
            }))
          );
          /*select the value when there is only one option while insert only*/
          if (response?.EmployeeList?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue(
              "IssueToEmployeeIDEncrypted",
              response?.EmployeeList[0].EmployeeIDEncrypted
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getInventoryItemsDDL = () => {
    setIsLoading(true);
    post(POST_GetInventoryItemsListDLL, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setItemsOptions(
            response?.List?.map((item) => ({
              label: item.ItemName,
              value: item.InventoryItemIDEncrypted,
              IsConsumable: item?.IsConsumable,
              ConsumptionUnit: item?.ConsumptionUnit,
              UnitName: item?.UnitName,
              IsItemStockSerialNumberWise: item?.IsItemStockSerialNumberWise,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const GetItemStockDetail = (id, StockSerialNumberWise) => {
    setIsLoading(true);
    post(POST_GetInventoryItemStockDDLListByID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InventoryItemIDEncrypted: id,
      IsItemWastage: false,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setItemStockOptions(
            response?.List?.map((item) => ({
              label: item.SerialNumber,
              value: item.InventoryItemStockIDEncrypted,
              UnitPrice: item?.UnitPrice,
              //IsConsumable: item?.IsConsumable,
              TotalAvailableQty: item?.TotalAvailableQty,
            }))
          );
        }

        formik.setFieldValue("InventoryItemStockIDEncrypted", "");
        if (response?.List?.length == 0) {
          setIsLoading(false);
          formik.setFieldError("ListOfItem", "Item Stock Not avaliable...");
          formik.setFieldTouched("ListOfItem", true);
          formik.setFieldValue("IsItemStockNot", true);
          return;
        }

        //alert(Consumable);
        //alert(response?.List[0].TotalAvailableQty);
        if (!StockSerialNumberWise) {
          formik.setFieldValue("Qty", response?.List[0].TotalAvailableQty);
          formik.setFieldValue(
            "TotalAvailableQty",
            response?.List[0].TotalAvailableQty ?? 0
          );
        } else {
          formik.setFieldValue("Qty", 1);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    IssueToEmployeeIDEncrypted: Yup.string()
      .trim()
      .required("Issue To Employee is required field"),
    IssueDate: Yup.string().required("Issue Date is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      InventoryItemIssueIDEncrypted: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      InventoryItemStockIDEncrypted: "",
      InventoryItemIDEncrypted: "",
      IssueToEmployeeIDEncrypted: "",
      ListOfItem: [],
      IssueDate: new Date(),
      Remarks: "",
      ItemIssueNumber: "",
      ItemName: "",
      UnitPrice: "",
      SerialNumber: "",
      Qty: 1,
      IsConsumable: false,
      ConsumptionUnit: "",
      UnitName: "",
      TotalAvailableQty: 0,
      IsItemStockNot: false,
      IsItemStockSerialNumberWise: true,
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    values: {
      InventoryItemStockIDEncrypted,
      InventoryItemIDEncrypted,
      ListOfItem,
      UnitPrice,
      ItemName,
      SerialNumber,
      ItemIssueNumber,
      Qty,
      IsConsumable,
      UnitName,
      ConsumptionUnit,
      TotalAvailableQty,
      IsItemStockNot,
      IsItemStockSerialNumberWise,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    const uniqueNumber = generateUniqueNumber(); // each time different

    if (values?.ListOfItem?.filter((x) => x?.IsDelete == false).length == 0) {
      formik.setFieldError(
        "ListOfItem",
        "Please fill all the above details of Item..."
      );
      formik.setFieldTouched("ListOfItem", true);
      return;
    } else {
      setIsLoading(true);

      let payload = {
        IssueDate: values?.IssueDate,
        Remarks: values?.Remarks,
        IssueToEmployeeIDEncrypted: values?.IssueToEmployeeIDEncrypted,
        ItemIssueNumber: values?.ItemIssueNumber
          ? values?.ItemIssueNumber.toString()
          : uniqueNumber,

        Listuddt: values?.ListOfItem?.filter((x) => x.IsDelete == false)?.map(
          (item) => {
            return {
              InventoryItemStockIDEncrypted:
                item?.InventoryItemStockIDEncrypted,
              InventoryItemIDEncrypted: item?.InventoryItemIDEncrypted,
              InventoryItemIssueIDEncrypted:
                item?.InventoryItemIssueIDEncrypted,
              Qty: item?.Qty,
              IsConsumable: item?.IsConsumable,
              IsItemStockSerialNumberWise: item?.IsItemStockSerialNumberWise,
              IsDelete: item?.IsDelete,
            };
          }
        ),

        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
        CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
          ? AuthUser?.ReferenceIDEncrypt
          : "0",
        ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
          ? AuthUser?.ReferenceIDEncrypt
          : "0",
      };

      //console.log("payload", payload);
      // return;
      post(POST_InventoryItemIssueInsert, payload)
        .then((response) => {
          setIsLoading(true);
          if (response?.IsSuccess) {
            successMessage(response?.Message);
            setTimeout(() => {
              navigate("/item-issue");
            }, 1000);
          } else {
            errorMessage(response?.Message);
            setIsLoading(false);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const generateUniqueNumber = () => {
    const now = new Date();

    // const year = now.getFullYear();
    // const month = (now.getMonth() + 1).toString().padStart(2, "0");
    // const day = now.getDate().toString().padStart(2, "0");
    // const hours = now.getHours().toString().padStart(2, "0");
    // const minutes = now.getMinutes().toString().padStart(2, "0");
    // const seconds = now.getSeconds().toString().padStart(2, "0");
    // const milliseconds = now.getMilliseconds().toString().padStart(3, "0");
    // // const random = Math.floor(Math.random() * 100)
    // //   .toString()
    // //   .padStart(3, "0");

    // //return `${year}${month}${day}${hours}${minutes}${seconds}${random}`; // 16 digits

    return moment(now).format("YYYYMMDDHHmmssSSS"); // 17 digits
  };

  const setAddItemStock = () => {
    let ItemExist = false;
    let existingList = formik.values.ListOfItem || [];

    let newValueList = [];

    if (!InventoryItemIDEncrypted) {
      formik.setFieldError(
        "InventoryItemIDEncrypted",
        "Item is required field"
      );
      formik.setFieldTouched("InventoryItemIDEncrypted", true);
      return;
    }

    if (IsItemStockSerialNumberWise) {
      if (!InventoryItemStockIDEncrypted) {
        formik.setFieldError(
          "InventoryItemStockIDEncrypted",
          "Item Stock is required field"
        );
        formik.setFieldTouched("InventoryItemStockIDEncrypted", true);
        return;
      }

      if (InventoryItemStockIDEncrypted) {
        ListOfItem?.map((x, idx) => {
          if (
            x.InventoryItemStockIDEncrypted === InventoryItemStockIDEncrypted &&
            x.InventoryItemIDEncrypted === InventoryItemIDEncrypted
          ) {
            ItemExist = true;
          }
        });
      }
    } else {
      if (Qty == 0 || Qty == "") {
        formik.setFieldError("ListOfItem", "Qty is required field");
        formik.setFieldTouched("ListOfItem", true);
        return;
      }
      if (Qty > TotalAvailableQty) {
        formik.setFieldError(
          "ListOfItem",
          "Qty not grater then Total Available Qty"
        );
        formik.setFieldTouched("ListOfItem", true);
        return;
      }

      if (InventoryItemIDEncrypted) {
        ListOfItem?.filter((x) => x?.IsDelete == false).map((x, idx) => {
          if (x.InventoryItemIDEncrypted === InventoryItemIDEncrypted) {
            ItemExist = true;
          }
        });
      }
    }

    if (ItemExist) {
      if (!IsItemStockSerialNumberWise) {
        formik.setFieldError("ListOfItem", "Selected Item already add...");
      } else {
        formik.setFieldError(
          "ListOfItem",
          "Selected Item Stock already add..."
        );
      }
      formik.setFieldTouched("ListOfItem", true);

      return;
    } else {
      newValueList.push({
        InventoryItemStockIDEncrypted: IsItemStockSerialNumberWise
          ? InventoryItemStockIDEncrypted
          : "0",
        InventoryItemIDEncrypted: InventoryItemIDEncrypted,
        InventoryItemIssueIDEncrypted: "",
        SerialNumber: IsItemStockSerialNumberWise ? SerialNumber : "",
        UnitPrice: IsItemStockSerialNumberWise ? UnitPrice : "-",
        ItemName: ItemName,
        Qty: IsItemStockSerialNumberWise ? 1 : Qty,
        IsConsumable: IsConsumable,
        IsItemStockSerialNumberWise: IsItemStockSerialNumberWise,
        IsDelete: false,
      });

      formik.setFieldValue(`ListOfItem`, [...existingList, ...newValueList]);
    }

    formik.setFieldValue("ItemName", "");
    formik.setFieldValue("InventoryItemIDEncrypted", "");
    formik.setFieldValue("InventoryItemStockIDEncrypted", "");
    formik.setFieldValue("SerialNumber", "");
    formik.setFieldValue("UnitPrice", "");
    formik.setFieldValue("Qty", 1);
    formik.setFieldValue("TotalAvailableQty", 0);
    formik.setFieldValue("IsConsumable", false);
    formik.setFieldValue("IsItemStockSerialNumberWise", true);
    formik.setFieldValue("ConsumptionUnit", "");

    setItemStockOptions([]);
  };

  const deleteItem = (i) => {
    if (ListOfItem[i]?.InventoryItemStockIDEncrypted) {
      formik.setFieldValue(
        "ListOfItem",
        ListOfItem?.map((x, idx) => {
          if (idx == i) {
            return {
              ...x,
              IsDelete: true,
            };
          } else {
            return { ...x };
          }
        })
      );
    } else {
      formik.setFieldValue(
        "ListOfItem",
        ListOfItem?.filter((x, idx) => idx != i)
      );
    }
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Item Issue
              </h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={3}>
                      <Field
                        label="Issue Date"
                        name="IssueDate"
                        placeholder={"Select Issue Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                          maxDate: new Date(),
                        }}
                        required
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Issue To Employee"
                        name="IssueToEmployeeIDEncrypted"
                        placeholder={"Select Employee"}
                        options={employeeOptions}
                        component={CustomSelect}
                        isClearable={false}
                        required
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        name={"Remarks"}
                        label={"Remarks"}
                        placeholder={"Remarks"}
                        component={CustomTextArea}
                        rows={4}
                        maxLength={2000}
                      />
                    </Col>
                  </Row>
                  <hr className="mt-1 mb-2"></hr>
                  <Row>
                    <Col lg={3}>
                      <Field
                        label="Item"
                        name="InventoryItemIDEncrypted"
                        placeholder={"Select Item"}
                        options={itemOptions}
                        component={CustomSelect}
                        isClearable={false}
                        onChange={(e) => {
                          formik.setFieldValue("ItemName", e?.label ?? "");
                          formik.setFieldValue(
                            "InventoryItemIDEncrypted",
                            e?.value ?? ""
                          );

                          formik.setFieldValue("IsConsumable", e?.IsConsumable);
                          formik.setFieldValue(
                            "IsItemStockSerialNumberWise",
                            e?.IsItemStockSerialNumberWise
                          );

                          formik.setFieldValue("UnitName", e?.UnitName);
                          formik.setFieldValue(
                            "ConsumptionUnit",
                            e?.ConsumptionUnit
                          );

                          formik.setFieldValue(
                            "TotalAvailableQty",
                            e?.TotalAvailableQty ?? 0
                          );

                          GetItemStockDetail(
                            e?.value ?? "",
                            e?.IsItemStockSerialNumberWise
                          );
                        }}
                      />
                    </Col>
                    {!IsItemStockSerialNumberWise ? (
                      <Col lg={3}>
                        <span
                          className="me-2 mt-1 fs-12 text-primary"
                          style={{ float: "right" }}
                        >
                          Total Available Qty : {TotalAvailableQty}
                        </span>
                        <Field
                          type="number"
                          label={`Qty ${
                            ConsumptionUnit ? "(" + ConsumptionUnit + ")" : ""
                          }`}
                          name="Qty"
                          placeholder={"Enter Qty"}
                          component={CustomInput}
                          maxLength={20}
                          numberTypeWithoutDot={true}
                          required
                          onChange={(e) => {
                            formik.setFieldValue("Qty", e?.target?.value ?? "");
                          }}
                        />
                      </Col>
                    ) : (
                      <Col lg={3}>
                        <Field
                          label="Item Stock"
                          name="InventoryItemStockIDEncrypted"
                          placeholder={"Select Item Stock"}
                          options={itemStockOptions}
                          component={CustomSelect}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "InventoryItemStockIDEncrypted",
                              e?.value ?? ""
                            );
                            formik.setFieldValue(
                              "SerialNumber",
                              e?.label ?? ""
                            );
                            formik.setFieldValue(
                              "UnitPrice",
                              e?.UnitPrice ?? ""
                            );
                          }}
                        />
                      </Col>
                    )}

                    <Col lg={3}>
                      <label style={{ marginTop: "22px" }}>
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm"
                          onClick={(e) => {
                            setAddItemStock();
                          }}
                        >
                          Add
                        </button>
                      </label>
                    </Col>
                  </Row>

                  {/* <hr className="mt-1 mb-2"></hr> */}
                  <Row>
                    <Col lg={12}>
                      <div className="card-header p-2">
                        <h4 className="card-title">Item Detail</h4>
                      </div>
                      <div className="card-body p-1">
                        <ErrorMessage
                          name={"ListOfItem"}
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="ItemDetail-tbl_wrapper"
                            className="dataTables_wrapper table-responsive no-footer "
                            style={{ overflowY: "auto" }}
                          >
                            <table
                              id="ItemDetail-tbl"
                              className="table dataTable no-footer mb-0 "
                            >
                              <thead className="fixedheader">
                                <tr>
                                  <th width="3%"></th>
                                  <th width="20%">Serial Number</th>
                                  <th width="20%">Item Name</th>
                                  <th width="10%">Qty</th>
                                  <th
                                    style={{
                                      width: "10%",
                                      textAlign: "left",
                                    }}
                                  >
                                    Unit Price
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfItem?.filter((x) => x.IsDelete == false)
                                  .length > 0 ? (
                                  ListOfItem?.map((item, indx) => (
                                    <tr
                                      style={{
                                        display:
                                          item.IsDelete == true ? "none" : "",
                                      }}
                                    >
                                      <td
                                        style={{
                                          textAlign: "center",
                                        }}
                                      >
                                        <Link
                                          to="#"
                                          className="icon-box icon-box-md me-1"
                                          title="Delete"
                                          onClick={() => {
                                            deleteItem(indx);
                                          }}
                                        >
                                          {SVGICON.DeleteDanger}
                                        </Link>
                                      </td>
                                      <td>{item?.SerialNumber}</td>
                                      <td>{item?.ItemName}</td>
                                      <td>{item?.Qty}</td>
                                      <td style={{ textAlign: "left" }}>
                                        {item?.UnitPrice}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={8}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <hr className="mt-1 mb-2"></hr>
                  <button type="submit" className="btn btn-primary btn-sm me-2">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default AddInventoryItemIssue;
